/**
 * @generated SignedSource<<496aae2805f190b889130185f14c15ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageDataSubTypeContentFragment$data = {
  readonly id: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "getCachedPageDataSubTypeContentFragment";
};
export type getCachedPageDataSubTypeContentFragment$key = {
  readonly " $data"?: getCachedPageDataSubTypeContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageDataSubTypeContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageDataSubTypeContentFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};

(node as any).hash = "03b28a640aee18909db0a4f3575e7f08";

export default node;
